import { CJEvent } from 'types/event';

export function groupEventsByClassroomIds(events: CJEvent[]): CJEvent[][] {
  const eventsByClassroom = events.reduce((acc, event) => {
    const key = event.classroomIds.join('%%');
    const group = acc.get(key) || [];
    acc.set(key, [...group, event]);
    return acc;
  }, new Map<string, CJEvent[]>());

  return Array.from(eventsByClassroom.values());
}
